<template>
  <LoginLayout noHeader>
    <Dialog
      v-if="error.isError"
      :title="error.title"
      :message="error.massage"
      @ok="onDialogOk"
      :okText="login.isTemporary ? 'OK' : '閉じる'"
    />
    <img :src="`${STATIC_PATH}/img/icons/logo_daicho.png?v=${app.cacheBuster}`" class="logo" />
    <h2 v-if="isCustomerManage">顧客情報管理ログイン</h2>
    <div class="form-box">
      <AdornmentsInput
        v-if="login.isTemporary"
        type="email"
        :prefixIcon="PersonIcon"
        :placeholder="'仮ID'"
        autocomplete="nope"
        v-model="tmpId"
        @keypress.enter="onSubmit"
      />
      <AdornmentsInput
        v-else
        type="email"
        :prefixIcon="MailInverseIcon"
        :placeholder="'メールアドレス'"
        autocomplete="nope"
        v-model="mail"
        @keypress.enter="onSubmit"
      />
    </div>
    <div class="form-box">
      <AdornmentsInput
        v-if="login.isTemporary"
        :type="passwordType"
        :prefixIcon="LockIcon"
        :placeholder="'仮パスワード'"
        autocomplete="nope"
        v-model="tmpPass"
        @keypress.enter="onSubmit"
        @focus="typeChange"
      />
      <AdornmentsInput
        v-else
        :type="passwordType"
        :prefixIcon="LockIcon"
        :placeholder="'パスワード'"
        autocomplete="nope"
        v-model="password"
        @keypress.enter="onSubmit"
        @focus="typeChange"
      />
    </div>
    <div v-if="!login.isTemporary" class="form-box check">
      <CheckBox v-if="!isCustomerManage" v-model="saveMail">
        {{ isWebView ? 'ログイン情報を保持する' : 'メールアドレスを保存する' }}
      </CheckBox>
    </div>
    <Button primary :disabled="!isDirty" @click="onSubmit">
      {{ login.isTemporary ? 'アカウント登録' : 'ログイン' }}
    </Button>
    <template #link v-if="!isCustomerManage && !login.isTemporary">
      <router-link :to="{ name: app.isSP ? 'SP/resetMail' : 'SendMail' }">パスワードをお忘れの方はこちら</router-link>
    </template>
  </LoginLayout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { models } from '@/utils/vue'
import { isWebView } from '@/utils/device'
import { dropOrigin } from '@/utils/url'
import CheckBox from '@/components/atoms/CheckBox'
import LoginLayout from '@/components/templates/LoginLayout'
import Dialog from '@/components/molecules/ModalDialog'
import Button from '@/components/atoms/Button'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import MailInverseIcon from '@/components/icons/mailInverse'
import LockIcon from '@/components/icons/lock'
import PersonIcon from '@/components/icons/person'

export default {
  name: 'Login',
  components: {
    Dialog,
    Button,
    CheckBox,
    LoginLayout,
    AdornmentsInput,
  },
  data() {
    return {
      passwordType: 'text',
      STATIC_PATH,
      MailInverseIcon,
      LockIcon,
      PersonIcon,
    }
  },
  computed: {
    ...mapState({
      app: state => state.app,
      error: state => state.login.error,
      login: state => state.login.login,
    }),
    ...mapGetters({
      isDirty: 'login/isDirty',
    }),
    isWebView: () => isWebView(),
    isCustomerManage() {
      return this.$route.query.url && this.$route.query.url.indexOf('/customer/csv') === 0
    },
    ...models(
      ['mail', 'password', 'saveMail', 'tmpId', 'tmpPass'],
      ({ login }, key) => login[key],
      ({ $store }, key, value) => $store.dispatch('login/setLoginData', { [key]: value }),
    ),
  },
  mounted() {
    this.$store.dispatch('login/init')
  },
  methods: {
    async onSubmit() {
      if (this.login.isTemporary) {
        if (await this.$store.dispatch('login/tmpLogin')) {
          this.$router.push({ path: `${this.app.isSP ? '/sp/registration' : '/login/open/registration'}` })
        }
      } else if (await this.$store.dispatch('login/checkLogin')) {
        location.replace(dropOrigin(this.$route.query.url || (this.app.isSP ? '/sp' : '/home/init')))
      }
    },
    onDialogOk() {
      const { dispatch, commit } = this.$store
      dispatch('login/updateIsError', false)
      commit('login/set', { tmpPass: '' })
    },
    typeChange() {
      this.passwordType = 'password'
    },
  },
}
</script>

<style lang="postcss" scoped>
.login {
  >>> .body > .box {
    min-height: auto;
    padding: 48px 56px 64px;
  }
}

.logo {
  align-self: center;
  height: 64px;
  width: 271px;
}

h2 {
  font-size: 21px;
  font-weight: 300;
  margin-bottom: 18px;
  text-align: center;
}

.button {
  margin-top: 32px;
}

.form-box {
  align-self: center;
  margin-top: 24px;
  width: 384px;

  &:first-of-type {
    margin-top: 32px;
  }

  &:not(.check) + .button {
    margin-top: 88px;
  }
}

.responsive {
  @media screen and (max-width: 559px) {
    .login {
      height: 100%;

      >>> .body > .box {
        padding: 24px 16px 30px;
      }
    }

    .logo {
      height: auto;
      max-width: 271px;
      width: 50%;
    }

    .button {
      font-size: 15px;
      height: 40px;
      line-height: normal;
      margin-top: 24px;
      width: 100%;
    }

    .form-box {
      margin-top: 24px;
      width: 100%;

      &.check {
        align-self: start;
        margin-left: 16px;
      }

      &:not(.check) + .button {
        margin-top: 40px;
      }
    }
  }
}
</style>
